import {
  OPEN_SNACKBAR,
  CLOSE_SNACKBAR
} from '../constants/ActionTypes'

const initialState = {
  display: false,
  status: "info", // info, error, success
  text: ""
}

export default function user(state = initialState, action) {
  switch (action.type) {
    case OPEN_SNACKBAR:
      return {
        display: true,
        status: action.status || "info",
        text: action.text
      }
    case CLOSE_SNACKBAR:
      return {
        display: false,
        status: "info",
        text: ""
      }

    default:
      return state
  }
}

